import {validators} from 'vue-form-generator';
import {invalidAccountNumber, invalidSortCode} from './customValidations';
import {setCustomValidationProperties} from '../../customValidationHelpers';

export const accountNumber = {
    type: 'input',
    inputType: 'text',
    label: '',
    id: 'account-number',
    model: 'accountNumber',
    required: true,
    disabled: false,
    styleClasses: "col xs-12",
    validator: [
        validators.string,
        setCustomValidationProperties(invalidAccountNumber, "invalidAccountNumber")
    ]
}


export const sortCode = {
    type: 'input',
    inputType: 'text',
    label: '',
    model: 'sortCode',
    required: true,
    disabled: false,
    styleClasses: "col xs-12",
    validator: [
        validators.string,
        setCustomValidationProperties(invalidSortCode, "invalidSortCode")
    ]
}
